import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ReportsService } from '../_services/reports.service';

@Injectable({
  providedIn: 'root'
})
export class SalesInvoiceDetailGuard implements CanActivate {
  constructor(
    private _router: Router,
    private _reportService: ReportsService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const invoiceNumber = this._reportService?.selectedInvoiceRow?.invoiceNumber;
    if (invoiceNumber && String(invoiceNumber).trim().length) {
      return true;
    }
    return this._router.parseUrl('/app/sales-orders');
  }
}

